let generation = 0

/**
 * Open a new app-context transition (initial mount or an org/group switch) and
 * return a `shouldCommit` guard bound to it. Each call supersedes the previous
 * context, so the returned guard reports `true` only until the next transition
 * begins — letting a superseded bootstrap/org-switch drop its stale Redux
 * writes instead of clobbering the latest context's results.
 */
export function beginBootstrapContext(): () => boolean {
    generation += 1
    const token = generation
    return () => token === generation
}
